import React, { memo, useEffect, useCallback, useState} from 'react';
import Resolution from 'engine/Resolution.js';
import {hashCode} from 'utils/hashCode.js';
import { createSelector } from 'reselect'
import Notes from 'midi/Notes.js';
import Colors from 'components/Colors.js';
import PianoRollGridStep from './PianoRollGridStep.js';
import {connect} from 'react-redux';
import StepData from 'pattern/StepData.js';

const baseResolution = new Resolution(32, false);
const colors = new Colors();
const DEFAULT_STEP = new StepData();

window.renders = 0;

const ToggledPianoRollSteps = (({
    sequencerEngine,
    track,
    color,
    height,
    xScale,
    parentClassName,
    resolution,
    selectedPianoRollSteps,
    noteIndex,
    leftSpace,
    rowSteps={},
    rowDurations={},
    rowPositions={},
}) => { 
    color = colors.saturate(color, window.saturation || 4.0);
    let state = sequencerEngine.state;
    window.renders++;
    
    let noteTranspose = (sequencerEngine.store.getState().keyboard.notes[noteIndex] ||
                Notes.NOTES[0]).getTranspose();

    let allPositions = state.tracks.allPositions[noteTranspose] || {};
    let allDurations = state.tracks.allDurations[noteTranspose] || {};
    let allSteps = state.tracks.allSteps[noteTranspose] || {};

    const getColorForTrack = (trackNumber) => {
        return colors.getColorForTrack(sequencerEngine.tracks[trackNumber]);
    };

    const getStepData = useCallback((stepNumber, _position) => {
        stepNumber = baseResolution.transformStepAtResolution2(parseFloat(stepNumber) + parseFloat(_position), resolution);
        let note = sequencerEngine.store.getState().keyboard.notes[noteIndex] ||
            Notes.NOTES[0];
        let pattern = track.getEasyPattern();
        let _stepNumber= Math.floor(stepNumber);
        let position = stepNumber - _stepNumber;
        let stepData = pattern.getStepWithTranspose(
            _stepNumber,
            baseResolution,
            note.getTranspose(),
            position);
        return stepData === undefined ? DEFAULT_STEP : stepData;
    }, [noteIndex, track, resolution]);

    let steps = state.tracks.trackSteps[
        track.subSequence.isTrack ?
            track.subSequence.id : track.id];
    let stepsLength = steps ? steps.length : 0;

    return (
        <div className="toggled-piano-roll-steps-container">
          {Object.keys(allSteps)
           .filter(stepNumber => stepNumber < stepsLength)
           .map(
              (stepNumber, i) =>
                  <PianoRollGridStep
                    key={i}
                    height={height}
                    leftSpace={leftSpace}
                    xScale={xScale}
                    position={allPositions[stepNumber]}
                    track={track}
                    sequencerEngine={sequencerEngine}
                    resolution={resolution}
                    parentClassName={parentClassName}
                    color={getColorForTrack(allSteps[stepNumber])}
                    on={true}
                    isGuideStep={true}
                    selectedPianoRollSteps={undefined}
                    duration={allDurations[stepNumber]}
                    stepNumber={stepNumber}
                    noteIndex={noteIndex}/>)}
          
          
          {Object.keys(rowSteps).map(
              (stepNumber, i) => {
                  let position = rowPositions[stepNumber];
                  let stepData = getStepData(stepNumber, position);
                  return (<PianoRollGridStep
                            key={i}
                            height={height}
                            track={track}
                            xScale={xScale}
                            position={rowPositions[stepNumber]}
                            sequencerEngine={sequencerEngine}
                            resolution={resolution}
                            leftSpace={leftSpace}
                            parentClassName={parentClassName}
                            color={color}
                            track={track}
                            on={true}
                            selectedPianoRollSteps={
                                selectedPianoRollSteps &&
                                    selectedPianoRollSteps.indexOf(stepData) > -1 ?
                                    selectedPianoRollSteps : undefined}
                            stepData={stepData}
                            isGuideStep={false}
                            duration={stepData.duration}
                            stepNumber={stepNumber}
                            noteIndex={noteIndex}/>);
              }
          )}
        </div>
    );
});

const mapStateToProps = (state, props) => {
    let noteTranspose = state.keyboard.notes[props.noteIndex] === undefined ?
        0 : state.keyboard.notes[props.noteIndex].getTranspose();
    let rowSteps = state.tracks.trackPianoRollSteps[
        props.track.subSequence.isTrack ?
            props.track.subSequence.id : props.track.id]; 
    let rowPositions = state.tracks.trackPianoRollPositions[
        props.track.subSequence.isTrack ?
            props.track.subSequence.id : props.track.id]; 
    let rowDurations = state.tracks.trackPianoRollDurations[
        props.track.subSequence.isTrack ?
            props.track.subSequence.id : props.track.id]; 

    return {
        rowSteps: rowSteps ? rowSteps[noteTranspose] : undefined,
        rowDurations: rowDurations ? rowDurations[noteTranspose] : undefined,
        rowPositions: rowPositions ? rowPositions[noteTranspose] : undefined,
        noteTranspose,
        selectedPianoRollSteps: state.keyboard.selectedPianoRollSteps,
        resolution: state.sequencer.displayResolution,
        currentPattern: rowSteps === undefined ? undefined : props.sequencerEngine.currentPattern,
        patternSelected: state.arrangement.patternSelected
    };
};

export default connect(mapStateToProps, null)(ToggledPianoRollSteps);
